module.exports = __webpack_public_path__ + "img/img_02_retail@3x.d9be916e.png";